import { Context } from '@sentry/angular';
import { getUrlParams } from './get-url-params';

interface ClientContext extends Context {
  userAgent: string;
  browserLanguage: string;
  platform: string;
  referrer: string;
  instance: string;
  gameLanguage: string;
  gameId: string;
}

export function getClientContext(): ClientContext {
  const { instance, language, gameId } = getUrlParams();

  return {
    userAgent: navigator.userAgent,
    browserLanguage: navigator.language,
    platform: navigator.platform,
    referrer: document.referrer,
    instance,
    gameLanguage: language,
    gameId,
  };
}
